import { Print } from "@mui/icons-material";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { Box, Modal, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import { UseCheckConsecutiveCharacters } from "../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import DatePickerFieldNew from "../../../../common/components/FormFields/DatePickerFieldNew";
import InputField from "../../../../common/components/FormFields/InputField";
import RadioField from "../../../../common/components/FormFields/RadioField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import {
  errorAlert,
  successAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import CommonPrintModal from "../../../../common/components/printModal/CommonPrintModal";
import {
  fetchAllPrintGrnList,
  fetchPrintGrnList,
} from "../../../services/generalStore/storeGRN/StoreGRNServices";
import {
  closeGrnForcefully,
  getGrnInfoByGrnId,
  getVerifyGrnItemDetailsList,
  getVerifyGrnList,
  postVerifyGrn,
} from "../../../services/generalStore/verifyGrn/VerifyGrnService";
import { getSupplierList } from "../../../services/generalStore/workOrderServices/WorkOrderServices";
import {
  DisableEditIcon,
  EditIcon,
  VerifyDisabledIcon,
  VerifyIcon,
} from "../../../../assets/CommonAssets";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import { CancelOffIcon, CloseIcon } from "../../../../assets/icons/CustomIcons";

const verificationObj = [
  {
    id: "All",
    value: "ALl",
    label: "All",
  },
  {
    id: "Pending",
    value: "Pending",
    label: "Pending",
  },
  {
    id: "Completed",
    value: "Completed",
    label: "Completed",
  },
];
const grnTypeObj = [
  {
    id: "All",
    value: "ALl",
    label: "All",
  },
  {
    id: "Daily Orders",
    value: "Daily Orders",
    label: "Daily Orders",
  },
  {
    id: "Direct Purchases",
    value: "Direct Purchases",
    label: "Direct Purchases",
  },
  {
    id: "D.C.",
    value: "D.C.",
    label: "D.C.",
  },
];
const paymentTypeObj = [
  {
    id: "All",
    value: "All",
    label: "All",
  },
  {
    id: "Cash",
    value: "Cash",
    label: "Cash",
  },
  {
    id: "Credit",
    value: "Credit",
    label: "Credit",
  },
];

const Actions = [
  {
    id: 0,
    action: "Verify Grn",
    isAction: true,
  },
  { id: 1, action: "Print", isAction: true },
  { id: 2, action: "Print All", isAction: false },
];

function GRNListModal(props) {
  const {
    openGRNListModal,
    setOpenGRNListModal,
    GRNListPrivilege,
    setDailyOrderDetailsData,
    setIsGRNEdit,
    setOpenBackdrop,
    setTotalCalculations,
  } = props;
  const defaultValues = {
    store: "",
    verification: "All",
    grnType: "All",
    paymentType: "All",
    searchItem: null,
    supplier: null,
    fromDate: new Date(),
    toDate: new Date(),
    converted: false,
    consignment: false,
    cancelled: false,
  };
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues,
  });
  let getUserInfo = JSON.parse(localStorage.getItem("userInfo"));
  const [supplierList, setSupplierList] = useState([]);
  const [supplierId, setSupplierId] = useState(0);
  const [getGrnList, setGetGrnList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [itemsDetailsData, setItemsDetailsData] = useState([]);
  const [urlforPrint, setUrlforPrint] = React.useState(); //table listing
  const [openPrintModal, setOpenPrintModal] = React.useState(false);
  const [urlForAllGrnPrint, setUrlForAllGrnPrint] = React.useState();
  const [openGrnPrintModal, setOpenGrnPrintModal] = React.useState(false);
  const [privilege, setPrivilege] = React.useState("");
  const [closeIndentForcefully, setCloseIndentForcefully] =
    React.useState(false);
  const [selectedRowData, setSelectedRowData] = React.useState(null);
  const [tableUserActions, setTableUserActions] = useState([]);
  const handleClosePrintModal = () => {
    setOpenPrintModal(false);
  };
  // watch veriables
  let fromDate = watch("fromDate");
  let toDate = watch("toDate");
  let verificationType = watch("verification");
  let grnType = watch("grnType");
  let isConverted = watch("converted");
  let consignment = watch("consignment");
  let cancelled = watch("cancelled");
  let paymentType = watch("paymmentType");
  // payment Type
  let paymentMode;
  if (paymentType === "All") {
    paymentMode = 2;
  } else if (paymentType === "Cash") {
    paymentMode = 0;
  } else if (paymentType === "Credit") {
    paymentMode = 1;
  }
  // consignment
  let isConsignment;
  if (consignment === false) {
    isConsignment = 0;
  } else if (consignment === true) {
    isConsignment = 1;
  }
  // isCancelled
  let isCancelled;
  if (cancelled === false) {
    isCancelled = 0;
  } else if (cancelled === true) {
    isCancelled = 1;
  }
  // verfiaction
  let isVerified;
  if (verificationType === "All") {
    isVerified = 2;
  } else if (verificationType === "Pending") {
    isVerified = 1;
  } else if (verificationType === "Completed") {
    isVerified = 0;
  }
  // grnType
  let isDirectPurchase;
  if (grnType === "All") {
    isDirectPurchase = 2;
  } else if (grnType === "Daily Orders") {
    isDirectPurchase = 0;
  } else if (grnType === "Direct Purchase") {
    isDirectPurchase = 1;
  } else if (grnType === "D.C.") {
    isDirectPurchase = 3;
  }

  // supplier
  const handleChangeGetSupplierList = (autoSearchString) => {
    if (
      autoSearchString !== "" &&
      UseCheckConsecutiveCharacters(autoSearchString)
    ) {
      getSupplierList(autoSearchString)
        .then((response) => response.data)
        .then((res) => {
          setSupplierList(res.result);
        });
    }
  };
  // grnList Table
  const populateTable = () => {
    setOpenBackdrop(true);
    let obj = {
      cashCredit: paymentMode,
      consignment: isConsignment,
      fromDate: fromDate,
      isCancelled: isCancelled,
      isConverted: isConverted,
      isDirectPurchase: isDirectPurchase,
      isVerified: isVerified,
      itemId: 0,
      storeId: getUserInfo.storeId,
      supplierId: supplierId,
      toDate: toDate,
      menuId: GRNListPrivilege?.menuId,
    };
    getVerifyGrnList(obj)
      .then((response) => response.data)
      .then((res) => {
        console.log("get my actions", res);

        setTableUserActions(res.actions);
        setGetGrnList(res.result);
        setOpenBackdrop(false);
      });
  };
  // itemDetails Table
  const datailsTable = () => {
    getVerifyGrnItemDetailsList(selectedRow?.GRNId, selectedRow?.StoreId)
      .then((response) => response.data)
      .then((res) => {
        setItemsDetailsData(res.result);
      });
  };

  // searchIcon Filter
  const filterData = () => {
    populateTable();
  };
  // grn list
  useEffect(() => {
    setValue("store", getUserInfo.storeName);
    populateTable();
  }, []);

  //grn details list
  React.useEffect(() => {
    if (selectedRow?.GRNId) {
      datailsTable();
    }
  }, [selectedRow]);

  const handleClickToAllPrint = () => {
    let fDate;
    let tDate;
    let fromFormatedDate = fromDate;
    let toFormatedDate = toDate;
    if (fromFormatedDate) {
      let fromDateStr = new Date(fromFormatedDate)
        .toISOString()
        .replaceAll("/", "-")
        .slice(0, -14);

      fDate = fromDateStr;
    }
    if (toFormatedDate) {
      let fromDateStr = new Date(toFormatedDate)
        .toISOString()
        .replaceAll("/", "-")
        .slice(0, -14);
      tDate = fromDateStr;
    }
    let obj = {
      fromDate: fDate,
      storeId: getUserInfo.storeId,
      toDate: tDate,
    };

    fetchAllPrintGrnList(obj).then((response) => {
      setUrlForAllGrnPrint(response);
    });
    setOpenGrnPrintModal(true);
  };

  //VerifyGRN Actions
  const [finalData, setFinalData] = React.useState({});
  const [openPost, setOpenPost] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleClosePost = () => {
    setOpenPost(false);
  };

  const addRecord = () => {
    setOpenPost(false);
    setOpenBackdrop(true);
    postVerifyGrn(GRNListPrivilege?.menuId, privilege, finalData)
      .then((response) => response.data)
      .then((res) => {
        if (res?.statusCode === 200) {
          successAlert(res.message);
          populateTable();
          setItemsDetailsData([]);
          setGetGrnList([]);
          datailsTable();
          setOpenBackdrop(false);
        } else if (res?.statusCode === 400) {
          setOpenBackdrop(false);
          setOpenErrorModal(true);
          setErrorMessage(res?.message);
        }
      })
      .catch((error) => {
        errorAlert(error.response.data.message || error.message);
        setOpenBackdrop(false);
      });
  };

  React.useEffect(() => {
    let tempArr = [itemsDetailsData];
    let reqArr = [];
    for (let detailsObj of tempArr) {
      for (let obj of detailsObj) {
        let expDate = new Date(obj["Batch Expiry Date"]);

        let reqObj = {};
        reqObj.grnId = selectedRow.GRNId;
        reqObj.storeId = selectedRow.StoreId;
        reqObj.acceptQty = Number(obj["Rect Qty"]) + Number(obj["Free Qty"]);
        reqObj.batchCode = obj["Batch Code"];
        reqObj.batchExpiryDate = expDate;
        reqObj.itemId = obj.ItemId;
        reqObj.poQty = obj["PO Qty"];
        reqObj.unitLandedRate = obj["Landed Net Rate"];
        reqObj.unitMrp = obj.MRP;
        reqObj.unitPurchaseRate = obj["Purchase Rate"];
        reqObj.vatPercentage = obj["GST Percentage"];
        reqObj.conversion = obj?.Conversion;
        reqArr.push(reqObj);
      }
    }
    setFinalData(reqArr);
  }, [selectedRow, itemsDetailsData]);

  const handleCloseGrnPrintModal = () => {
    setOpenGrnPrintModal(false);
  };

  const handleSelectedRow = (row, index) => {
    setSelectedRow(row);
  };

  const renderActions = (row, index) => {
    return (
      <div className="flex space-x-2 items-center">
        {tableUserActions?.map((actions, i) => (
          <>
            {actions?.isAction === true && actions?.action === "Edit" && (
              <>
                {row?.Verified === false ? (
                  <Tooltip title="Edit GRN">
                    <button
                      type="button"
                      onClick={() => {
                        if (row?.["rounding"]) {
                          props?.setRoundingValue(row?.["rounding"]);
                        }
                        getGRNInfo(row);
                      }}
                    >
                      <EditIcon />
                    </button>
                  </Tooltip>
                ) : (
                  <button disabled>
                    <DisableEditIcon />
                  </button>
                )}
              </>
            )}
            {actions?.isAction === true && actions?.action === "Verify" && (
              <>
                {row?.Verified === false ? (
                  <Tooltip title="Verify GRN">
                    <div
                      className="text-customBlue cursor-pointer"
                      onClick={() => {
                        setPrivilege(actions.action);
                        setOpenPost(true);
                        setSelectedRow(row);
                      }}
                    >
                      <VerifyIcon className="pl-3" />
                    </div>
                  </Tooltip>
                ) : (
                  <button disabled>
                    <VerifyDisabledIcon />
                  </button>
                )}
              </>
            )}

            {actions?.isAction === true && actions?.action === "Print" && (
              <Tooltip title="Print">
                <div
                  className="text-gray-600 cursor-pointer"
                  onClick={() => {
                    fetchPrintGrnList(row?.GRNId).then((response) => {
                      setUrlforPrint(response);
                    });
                    setOpenPrintModal(true);
                  }}
                >
                  <Print />
                </div>
              </Tooltip>
            )}

            {actions?.isAction === true && actions?.action === "Verify" && (
              <>
                {row?.Verified === false ? (
                  <Tooltip title="Print">
                    <div
                      className="text-gray-600 cursor-pointer"
                      onClick={() => {
                        setSelectedRowData(row);
                        setCloseIndentForcefully(true);
                      }}
                    >
                      <CloseIcon />
                    </div>
                  </Tooltip>
                ) : (
                  <button>
                    <CancelOffIcon />
                  </button>
                )}
              </>
            )}
          </>
        ))}
      </div>
    );
  };

  const getGRNInfo = (row) => {
    setIsGRNEdit(false);
    getGrnInfoByGrnId(row?.GRNId).then((response) => {
      if (response?.data?.result?.length > 0) {
        console.log("ddddddddddaaaaaaaaaa", response.data.result);
        props?.setDataComingFrom("grnList");
        props?.setSelectedGrn(row);
        setDailyOrderDetailsData(response?.data?.result);
        setOpenGRNListModal(false);
        setIsGRNEdit(true);
        setTotalCalculations(null);
      } else {
        setDailyOrderDetailsData([]);
        setOpenGRNListModal(false);
        setIsGRNEdit(false);
      }
    });
  };
  
  function handleCloseGRNForcefully(data) {
    closeGrnForcefully(data?.GRNId)
      .then((response) => response.data)
      .then((res) => {
        populateTable();
        successAlert(res?.message);
        setCloseIndentForcefully(false);
      });
  }
  return (
    <Modal open={openGRNListModal}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95%",
          height: "90%",
          bgcolor: "background.paper",
          boxShadow: 20,
          p: 2,
          overflow: "auto",
        }}
        className="space-y-2"
      >
        <div className="flex justify-between w-full">
          <label className="text-lg font-semibold w-full">GRN List</label>
          <CancelPresentationIconButton
            onClick={() => {
              setOpenGRNListModal(false);
            }}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5 items-center gap-3 w-full">
          <div className="flex space-x-2 w-full col-span-2">
            <fieldset className="flex gap-1 justify-center items-center bg-white border rounded px-2 -mt-2 h-full w-max">
              <legend className="font-semibold text-xs px-2">
                Verification
              </legend>
              <div className="-my-1">
                <RadioField
                  name="verification"
                  className="whitespace-nowrap"
                  control={control}
                  dataArray={verificationObj}
                />
              </div>
            </fieldset>
            <fieldset className="flex gap-1 justify-center items-center bg-white border rounded px-2 -mt-2 h-full w-max">
              <legend className="font-semibold text-xs px-2">GRN Type</legend>
              <div className="-my-1">
                <RadioField
                  name="grnType"
                  control={control}
                  dataArray={grnTypeObj}
                />
              </div>
            </fieldset>
          </div>
          <div className="flex space-x-2 ">
            <DatePickerFieldNew
              control={control}
              name="fromDate"
              label="From Date"
              value={new Date()}
              onChange={(newValue) => {
                setValue("fromDate", newValue);
              }}
              disableFuture={true}
              inputFormat="dd-MM-yyyy"
            />
            <DatePickerFieldNew
              control={control}
              name="toDate"
              label="To Date"
              value={new Date()}
              onChange={(newValue) => {
                setValue("toDate", newValue);
              }}
              disableFuture={true}
              inputFormat="dd-MM-yyyy"
            />
          </div>
          <div className="">
            <InputField control={control} label="Store" name="store" disabled />
          </div>
          <div className="w-full">
            <SearchDropdown
              control={control}
              searchIcon={true}
              isDisabled={false}
              isSearchable={true}
              isClearable={true}
              error={errors.supplierName}
              name="supplierName"
              placeholder="Supplier Name*"
              dataArray={supplierList}
              handleInputChange={handleChangeGetSupplierList}
              inputRef={{
                ...register(`supplierName`, {
                  onChange: (e) => {
                    if (e.target.value === null) {
                      setSupplierId(0);
                    } else {
                      setSupplierId(e.target.value.id);
                    }
                  },
                }),
              }}
            />
          </div>
          <div className="flex whitespace-nowrap">
            <CheckBoxField
              control={control}
              name="converted"
              label="Converted"
            />
            <CheckBoxField
              control={control}
              name="consignment"
              label="Consignment"
            />
            <CheckBoxField control={control} name="cancel" label="Cancelled" />
          </div>
          <fieldset className="flex gap-1 justify-center items-center bg-white border rounded px-2 -mt-2 h-full">
            <legend className="font-semibold text-xs px-2">Payment Type</legend>
            <div className="-my-1">
              <RadioField
                name="paymentType"
                control={control}
                dataArray={paymentTypeObj}
              />
            </div>
          </fieldset>
          <div>
            <CommonButton
              type="button"
              className="bg-customBlue text-white"
              searchIcon={true}
              onClick={filterData}
            />
          </div>
        </div>
        <div>
          {getGrnList.length > 0 ? (
            <div className="flex items-center justify-between w-full py-1">
              <h1 className="font-semibold text-base 2xl:text-lg">GRN List</h1>

              {tableUserActions.map((actions, i) => (
                <>
                  {actions.action === "Print All" ? (
                    <Tooltip title="Print All">
                      <LocalPrintshopIcon
                        sx={{ color: "#E3902F", cursor: "pointer" }}
                        onClick={() => {
                          handleClickToAllPrint();
                        }}
                      />
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>
          ) : null}

          {getGrnList.length > 0 ? (
            <CommonDynamicTableNew
              dataResult={getGrnList}
              actionsRequired={true}
              renderActions={renderActions}
              handleSelectedRow={handleSelectedRow}
              removeHeaders={[
                "StoreId",
                "SupplierId",
                "IsClosed",
                "IsCancelled",
                "Cash_Credit",
                "GRNId",
                "IsDirectPurchase",
                "ReceivedBy",
              ]}
              highlightRow={true}
              tableClass={"rounded h-40 2xl:h-60 border"}
            />
          ) : (
            <h1 className="flex justify-center mt-14 font-semibold">
              No Record Found...
            </h1>
          )}
        </div>
        <div className="mt-2">
          <h1 className="font-semibold text-base 2xl:text-lg">
            GRN Details List
          </h1>

          {itemsDetailsData.length > 0 ? (
            <div>
              {/* <GrnItemDetailsTable data={itemsDetailsData} /> */}
              <CommonDynamicTableNew
                dataResult={itemsDetailsData}
                tableClass={"rounded h-40 2xl:h-60 border"}
                highlightRow={false}
                removeHeaders={["ItemId", "GRNDetailId"]}
              />
            </div>
          ) : (
            <h1 className="flex justify-center mt-14 font-semibold">
              No Record Found...
            </h1>
          )}
        </div>
        {openPrintModal ? (
          <CommonPrintModal
            open={openPrintModal}
            setOpen={setOpenPrintModal}
            // handleOpen={handleClickToAllPrint}
            handleClose={handleClosePrintModal}
            urlforPrint={urlforPrint}
          />
        ) : null}

        {openGrnPrintModal ? (
          <CommonPrintModal
            open={openGrnPrintModal}
            setOpen={setOpenGrnPrintModal}
            // handleOpen={handleOpenGrnPrintModal}
            handleClose={handleCloseGrnPrintModal}
            urlforPrint={urlForAllGrnPrint}
          />
        ) : null}

        <ConfirmationModal
          confirmationOpen={openPost}
          confirmationHandleClose={handleClosePost}
          confirmationSubmitFunc={addRecord}
          confirmationLabel="Confirmation"
          confirmationMsg="Are you sure want to Verify this grn record ?"
          confirmationButtonMsg="Add"
        />
        <Modal
          open={openErrorModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              border: "2px solid #848211",
              borderRadius: "0.5rem",
              boxShadow: 24,
              px: 4,
              pb: 4,
            }}
          >
            <div className=" justify-center align-middle">
              <p className="my-1 tracking-wide text-lg">{errorMessage}</p>
              <div className="mt-3 flex  justify-center space-x-4">
                <CommonButton
                  type="button"
                  label="Close"
                  onClick={() => {
                    setOpenErrorModal(false);
                    setErrorMessage("");
                  }}
                  className="border border-customRed text-customRed"
                />
              </div>
            </div>
          </Box>
        </Modal>

        <Modal open={closeIndentForcefully}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { sm: "40%", lg: "25%" },
              bgcolor: "background.paper",
              borderRadius: 2,
              border: "none",
              "&:focus": {
                outline: "none",
              },
              // boxShadow: 24,
              // p: 4,
            }}
          >
            <div className="mx-3 mb-3 mt-2 items-center align-middle">
              <div className=" p-2 rounded  text-black font-semibold whitespace-nowrap">
                Close Indent
              </div>

              <hr className="border mx-1  border-blue-900" />
              <div className=" p-2 rounded  text-black  whitespace-nowrap">
                Do You Want To Close Indent Forcefully ?
              </div>
              <div className="flex justify-end my-2 gap-3">
                <div>
                  <CommonButton
                    className="border border-customRed text-customRed"
                    label="Cancel"
                    onClick={() => {
                      setCloseIndentForcefully(false);
                    }}
                  />
                </div>

                <div>
                  <div>
                    <CommonButton
                      type="submit"
                      label="Ok"
                      className="bg-customGreen text-white "
                      onClick={() => {
                        handleCloseGRNForcefully(selectedRowData);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      </Box>
    </Modal>
  );
}

export default GRNListModal;
